import { Component, EventEmitter, Input, Output } from '@angular/core'

@Component({
    selector: 'modal-confirm',
    styleUrls: ['./modal.component.scss'],
    templateUrl: './modal.component.html'
})
export class ModalComponent {
    @Input() cModal: any = {};
    @Output() onBtnSelection = new EventEmitter<boolean>();

    modalHandler(btnOutput: boolean) {
        this.onBtnSelection.emit(btnOutput);
        this.cModal.state = false;
    }
}



// WEBPACK FOOTER //
// ./src/app/common/modal/modal.component.ts